import NProgress from 'nprogress'; // 导入进度条插件
import 'nprogress/nprogress.css';// 在index.html同过cnd引入了

NProgress.configure({ showSpinner: false });
export { NProgress };



// WEBPACK FOOTER //
// ./src/util/nprogress.js